/**
 * Shared utility functions for the Station Assignment feature.
 */

/**
 * Format a full name as "First L." for compact display.
 * Two or more tokens: "First L." — single token or empty: unchanged.
 */
export function formatDisplayName(name: string): string {
  const tokens = name.trim().split(/\s+/).filter(t => t.length > 0);
  if (tokens.length >= 2) {
    return `${tokens[0]} ${tokens[tokens.length - 1][0]}.`;
  }
  return name;
}

export const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return '?';
  }
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return parts[0].charAt(0).toUpperCase() + parts[parts.length - 1].charAt(0).toUpperCase();
};